import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";

import { isAdmin } from "../services/authService";
import UTable from "./common/table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHammer } from "@fortawesome/free-solid-svg-icons";
import { isShopInRenovation } from "../utils/shopManagerData";
class ShopsTable extends Component {
  columns = [
    {
      path: "name",
      label: "Nr. drogerii",
    },
    {
      path: "city",
      label: "Miasto",
    },
    {
      path: "adress",
      label: "Adres",
    },
    {
      path: "postCode",
      label: "Kod pocztowy",
    },
  ];

  renovationColumn = {
    path: "",
    key: "renovation",
    content: (item) => {
      if (item.shopManagerData) {
        if(isShopInRenovation(item.shopManagerData)){
          return (
            <Badge bg="warning" text="dark">
              <FontAwesomeIcon icon={faHammer} /> Remont
            </Badge>
          );
        }
      }
      return "";
    },
  };

  closeColumn = {
    path: "",
    key: "close",
    content: (item) => {
      if (item.shopManagerData) {
        if (item.shopManagerData.CloseDate && item.shopManagerData.CloseDate !== "") {
          const closeDate = new Date(item.shopManagerData.CloseDate);
          const currentDate = new Date();
          if (closeDate < currentDate) {
            return (
              <Badge bg="secondary" >
                Zamknięte
              </Badge>
            );
          }
        }
        
      }
      return "";
    },
  };

  editColumn = {
    path: "",
    key: "edit",
    content: (item) => (
      <Button
        variant="warning"
        className="my-0"
        size="sm"
        onClick={(e) => this.props.onEdit(e, item)}
      >
        Edytuj
      </Button>
    ),
  };

  constructor() {
    super();
    // if(isAdmin()){
    this.columns.push(this.renovationColumn);
    this.columns.push(this.closeColumn);
    this.columns.push(this.editColumn);
    // }
  }

  render() {
    const { shops, sortColumn, onSort, onRowClick } = this.props;

    return (
      <UTable
        columns={this.columns}
        onSort={onSort}
        sortColumn={sortColumn}
        data={shops}
        onRowClick={onRowClick}
        dataId="_id"
      />
    );
  }
}

export default ShopsTable;
